import { useDisclosure } from "@mantine/hooks";
import { useFieldArray } from "react-hook-form";

import { SectionProps } from "#modules/company/view/QuoteSettingsFormSections";
import { CreateProductModal } from "#modules/products/view/CreateProductModal";
import { useProducts } from "#modules/products/view/useProducts";
import { Icon } from "#shared/icons/Icon";
import { Group } from "#shared/view/components/Group";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { Title } from "#shared/view/components/Title";
import { Button } from "#shared/view/designSystem/Button";
import { NativeSelectInputController } from "#shared/view/designSystem/inputs/NativeSelectInputController";
import { formatPrice, Product } from "shared";

export const DefaultProductLinesSettings = ({ control }: SectionProps) => {
  const { products } = useProducts();
  const [isCreateModalOpen, { open: openCreateModal, close: closeCreateModal }] =
    useDisclosure(false);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "defaultProducts",
  });

  const productOptions = products.map((product) => ({
    value: product.id,
    label: `${product.name} - ${formatPrice(product.price)}`,
  }));

  const addDefaultProduct = () => {
    append({
      id: "NEW_DEFAULT_PRODUCT",
      name: "",
      type: "CONSUMABLE",
      price: 0,
      fixedPrice: 0,
      companyId: null,
      companySettingsId: null,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
  };

  const handleProductCreated = (newProduct: Product) => {
    append(newProduct);
  };

  return (
    <Stack gap="sm">
      <Title order={5}>Achats par défaut</Title>

      <Text size="sm" c="dimmed">
        Ces achats seront automatiquement ajoutés à toutes les nouvelles lignes de demande de devis
      </Text>

      {fields.map((field, index) => {
        return (
          <Group key={field.id} align="flex-end">
            <NativeSelectInputController
              name={`defaultProducts.${index}.id`}
              label="Produit"
              control={control}
              data={productOptions}
            />

            <Button
              variant="outline"
              color="red"
              size="sm"
              onClick={() => remove(index)}
              leftSection={<Icon name="trash" />}
            >
              Supprimer
            </Button>
          </Group>
        );
      })}

      <Group>
        <Button variant="outline" leftSection={<Icon name="plus" />} onClick={addDefaultProduct}>
          Ajouter un achat par défaut
        </Button>
        <Button
          variant="subtle"
          size="xs"
          leftSection={<Icon name="plus" />}
          onClick={openCreateModal}
        >
          Créer un nouveau produit
        </Button>
      </Group>

      <CreateProductModal
        opened={isCreateModalOpen}
        onClose={closeCreateModal}
        onSuccess={handleProductCreated}
      />
    </Stack>
  );
};
